import { BaseInsuranceStatus } from '@/classes/SubmissionStatuses/BaseInsuranceStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class SuccessStatus extends BaseInsuranceStatus {
	getToolTipText() {
		return {
			title: this.getVendorName() + ' Submission Successful',
			body:
				'This packet submitted successfully to ' + this.getVendorName() + '.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.SUCCESS
	}
}
